<script>
    import Vue from 'vue';
    import { firestorePlugin } from 'vuefire'
    import {DB} from "../../../firebase/db";

    import CreateNew from './create';
    import EditApplication from './edit';
    import CodeWidget from './code';
    import {Storage} from "../../../firebase/storage";
    import { Notification } from 'element-ui';

    Vue.use(firestorePlugin);

    export default {

        components: { CreateNew, EditApplication, CodeWidget },

        firestore() {
            return {
                applications: DB.collection('applications')
                    .where('project_id', '==', this.projectId)
            }
        },

        computed: {
            projectId() {
                return this.$route.params.project;
            }
        },

        data() {
            return {
                applications: [],
                logoDialog: false,
                selectedApplication: {},
                imageData: null,
                picture: null,
                uploadValue: 0,
                uploading: false,
                deleting: false
            }
        },

        methods: {

            onUpload(){

                this.uploading = true;

                this.picture = null;

                this.uploadedData = event.target.files[0];

                let ext = this.uploadedData.name.split('.').pop();

                let storageRef = Storage.ref(`chatuploads/${this.type}s/${this.uploadedData.name}`).put(this.uploadedData);

                storageRef.on(`state_changed`, snapshot=> {
                    this.uploadValue = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
                }, error => {}, ()=> {

                    this.uploadValue = 100;

                    storageRef.snapshot.ref.getDownloadURL().then((url) => {
                        DB.collection('applications')
                            .doc(this.selectedApplication.id)
                            .set({
                                url: url
                            }, { merge: true })
                            .then(() => {
                                this.logoDialog = false;
                                this.uploading = false;
                            }, () => {
                                this.logoDialog = false;
                                this.uploading = false;
                            });
                    });

                    this.uploading = false;
                });
            },

            upload(application) {
                this.selectedApplication = application;
                this.logoDialog = true;
            },

            editApplication(application) {
                this.$store.commit('SET_ACTIVE_APPLICATION', {
                    value: true,
                    application: application
                });
            },

            deleteApplication(id) {

                this.$confirm('This will permanently delete the application. Continue?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    this.remove(id);
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Delete canceled'
                    });
                });
            },

            remove(id) {
                this.deleting = true;

                DB.collection('applications').doc(id).delete()
                    .then( () => {
                        this.deleting = false;
                        Notification.success({
                            title: 'Success',
                            message: 'Application deleted successfully!',
                            position: 'bottom-right'
                        });
                    }, () => {
                        this.deleting = false;
                        Notification.error({
                            title: 'Failed',
                            message: 'Application failed to delete, please try again later!',
                            position: 'bottom-right'
                        });
                    });
            }
        }
    }
</script>

<template>
    <div class="">

        <br>

        <create-new/>

        <hr>

        <el-table
            ref="filterTable"
            :data="applications"
            style="width: 100%">

            <el-table-column
                type="index"
                label="#"
                width="50">
            </el-table-column>

            <el-table-column
                prop="name"
                label="Web App Name"
                width="180">
            </el-table-column>

            <el-table-column
                prop="hostname"
                label="Host Name">
            </el-table-column>

            <el-table-column
                prop="customer_account"
                label="Customer Account">
            </el-table-column>

            <el-table-column
                prop="color"
                label="Background Color">
                <template slot-scope="scope">
                    <div
                        class="color-indicator"
                        :style="{ background: scope.row.color }">
                    </div>
                </template>
            </el-table-column>

            <el-table-column
                prop="color"
                label="Icon Logo">
                <template slot-scope="scope">

                    <el-button
                        size="mini"
                        @click="upload(scope.row)"
                        v-if="scope.row.url === undefined || scope.row.url === ''">
                        <i class="el-icon-upload"/>
                    </el-button>

                    <span
                        v-else
                        class="application-logo"
                        @click="upload(scope.row)">
                        <img :src="scope.row.url" alt="" length>
                    </span>

                </template>
            </el-table-column>

            <el-table-column
                label="Get the widget">
                <template slot-scope="scope">
                    <code-widget/>
                </template>
            </el-table-column>

            <el-table-column
                prop="color"
                label="Actions">
                <template slot-scope="scope">
                    <el-button-group>

                        <el-button
                            size="mini"
                            type="primary"
                            class="el-icon-edit"
                            @click="editApplication(scope.row)"
                        />

                        <el-button
                            size="mini"
                            type="danger"
                            class="el-icon-delete"
                            @click="deleteApplication(scope.row.id)"
                        />
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog
            title="Upload System Logo"
            :visible.sync="logoDialog"
            width="22%">

            <div class="">
                <div class="upload-section">

                    <label for="">Upload logo here:</label>

                    <br>

                    <input
                        type="file"
                        @change="onUpload"
                        accept="image/*"
                        placeholder="Image"
                    >

                    <br>

                    <span v-if="uploading">
                        <i class="el-icon-loading loading-icon" v-if="uploading"/> Uploading
                    </span>

                </div>
            </div>

        </el-dialog>

        <edit-application/>
    </div>
</template>

<style lang="scss" scoped>

    .color-indicator {
        width: 25px;
        height: 25px;
        border-radius: 50%;
    }

    .application-logo {
        cursor: pointer;

        img {
            border-radius: 50%;
            width: 30px;
            height: 30px;
            cursor: pointer;
        }
    }
</style>
